<template>
  <span>
    <template v-for="part in parts" :key="part.text">
      <mark v-if="part.hit">{{ part.text }}</mark>
      <template v-else>{{ part.text }}</template>
    </template>
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

interface Props {
  /** Term to display with highlighting */
  term: string
  /** Array of character offsets for highlighting.  Supports highlighting multiple parts of the term */
  highlightParts: Array<[number, number]>
  /** Whether the end index is inclusive for highlighting */
  endIndexInclusive?: boolean
}
const { term, highlightParts, endIndexInclusive = true } = defineProps<Props>()

type LabelHighlightSections = Array<{ text: string; hit: boolean }>

const parts = computed<LabelHighlightSections>(() => {
  if (!highlightParts || highlightParts.length === 0) {
    return [{ text: term, hit: false }]
  }

  const result = []
  let lastIndex = 0

  for (const [start, end] of highlightParts) {
    // Add text before the highlight if any
    if (start > lastIndex) {
      result.push({ text: term.slice(lastIndex, start), hit: false })
    }

    // Add the highlighted text
    const endingIndex = endIndexInclusive ? end + 1 : end
    result.push({ text: term.slice(start, endingIndex), hit: true })
    lastIndex = endingIndex
  }

  // Add any remaining text after the last highlight
  if (lastIndex < term.length) {
    result.push({ text: term.slice(lastIndex), hit: false })
  }

  return result
})
</script>

<style scoped lang="scss">
mark {
  font-weight: 700;
  color: var(--ys-color-text-primary);
  background: transparent;
}
</style>
